import { imageUrl } from '@helpers/image';
import { useScrollHandler } from '@hooks/useScrollHandler';
import * as React from 'react';
import DesktopNavigation from './DesktopNavigation/DesktopNavigation';
import S from './Header.styles';
import MobileHeader from './MobileHeader/MobileHeader';
import MobileNavigation from './MobileNavigation/MobileNavigation';
import SearchOverlay from './SearchOverlay/SearchOverlay';
import TopLinks from './TopLinks/TopLinks';
const SCROLL_THRESHOLD = 50;
const Header = ({ alwaysActive, logoAltText, logoColor, logoGreyscale, navigation, reduced = false, scrollThreshold = SCROLL_THRESHOLD, search, topLinks, }) => {
    const [isScrolled, setIsScrolled] = React.useState(false);
    const [isNavigationActive, setIsNavigationActive] = React.useState(false);
    const [isSearchActive, setIsSearchActive] = React.useState(false);
    useScrollHandler(() => setIsScrolled(window.scrollY > scrollThreshold), true);
    React.useEffect(() => {
        if (isNavigationActive) {
            setIsSearchActive(false);
        }
    }, [isNavigationActive]);
    React.useEffect(() => {
        if (isSearchActive) {
            setIsNavigationActive(false);
        }
    }, [isSearchActive]);
    return (React.createElement(S.Root, { "data-active": alwaysActive || isScrolled || isNavigationActive || isSearchActive, "data-reduced": reduced },
        React.createElement(S.GlobalStyles, { reduced: reduced }),
        React.createElement(S.Container, null,
            React.createElement(S.Inner, null,
                React.createElement(S.LogoWrapper, { href: "/" },
                    React.createElement(S.LogoGreyscale, { alt: logoAltText, loading: "eager", src: imageUrl({ src: logoGreyscale }, { width: 286, height: 78 }), width: "286", height: "78" }),
                    React.createElement(S.LogoColor, { alt: logoAltText, role: "presentation", loading: "eager", src: imageUrl({ src: logoColor }, { width: 286, height: 78 }), width: "286", height: "78", "aria-hidden": true })),
                topLinks && React.createElement(TopLinks, { items: topLinks }),
                React.createElement(DesktopNavigation, { items: navigation, reduced: reduced, onSearchToggle: () => {
                        setIsSearchActive(!isSearchActive);
                    } }),
                React.createElement(MobileHeader, { isActive: isNavigationActive, isSearchActive: isSearchActive, reduced: reduced, onNavigationToggle: () => {
                        setIsNavigationActive(!isNavigationActive);
                    }, onSearchToggle: () => {
                        setIsSearchActive(!isSearchActive);
                    } }))),
        !reduced && (React.createElement(MobileNavigation, { isActive: isNavigationActive, items: navigation, otherItems: topLinks })),
        React.createElement(SearchOverlay, { ...search, isActive: isSearchActive })));
};
export default Header;
